<template>
  <div>
    <div class="elevation-1">
      <v-toolbar flat color="white">
        <v-toolbar-title>
          RELAÇÃO DE DOCUMENTOS POR FRANQUEADO
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          bottom
          color="deep-purple accent-4"
        ></v-progress-linear>
      </v-toolbar>
      <v-alert type="success" v-if="successSave">
        <template v-slot:close>
          <v-icon @click="() => (successSave = false)"> mdi-close </v-icon>
        </template>
        Salvo com Sucesso
      </v-alert>
      <v-form ref="form" v-model="valid" :lazy-validation="lazy">
        <v-container fluid>
          <v-row>
            <v-col cols="12" xs="12" md="5" lg="5">
              <v-select
                :items="companies"
                :item-text="(item) => `${item.code} - ${item.name}`"
                item-value="id"
                v-model="company"
                label="Franqueado"
                hide-details
                clearable
                dense
                outlined
              ></v-select>
            </v-col>
            <v-col cols="12" xs="6" md="2">
              <v-select
                :items="months"
                v-model="month"
                label="Mês"
                hide-details
                dense
                outlined
              ></v-select>
            </v-col>
            <v-col cols="12" xs="6" md="2">
              <v-select
                :items="years"
                v-model="year"
                label="Ano"
                hide-details
                dense
                outlined
              ></v-select>
            </v-col>
            <v-col cols="12" xs="12" md="2">
              <v-btn dark color="blue darken-3" small class="mt-1">
                Executar Consulta
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="py-1">
              <v-card outlined rounded>
                <v-card-text>
                  <v-row>
                    <v-col class="py-1">
                      <v-simple-table dense fixed-header height="350">
                        <template v-slot:default>
                          <thead>
                            <tr>
                              <th class="text-left fs-12 text-no-wrap"></th>
                              <th class="text-left fs-12 text-no-wrap">
                                Protocolo
                              </th>
                              <th class="text-left fs-12" width="250px">
                                Descrição
                              </th>
                              <th class="text-left fs-12 text-no-wrap">
                                Publicado
                              </th>
                              <th class="text-left fs-12 text-no-wrap">
                                Gerado Por:
                              </th>
                              <th class="text-left fs-12 text-no-wrap">
                                Visualizado
                              </th>
                              <th class="text-left fs-12 text-no-wrap">
                                Status
                              </th>
                            </tr>
                          </thead>
                          <tbody></tbody>
                        </template>
                      </v-simple-table>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </div>
  </div>
</template>
<script>
// import { URL } from "@/api/config";

import * as CompanyAPI from "@/api/requests/CompanyRequest";

export default {
  components: {},
  data: () => ({
    months: [
      { value: 1, text: "Janeiro" },
      { value: 2, text: "Fevereiro" },
      { value: 3, text: "Março" },
      { value: 4, text: "Abril" },
      { value: 5, text: "Maio" },
      { value: 6, text: "Junho" },
      { value: 7, text: "Julho" },
      { value: 8, text: "Agosto" },
      { value: 9, text: "Setembro" },
      { value: 10, text: "Outubro" },
      { value: 11, text: "Novembro" },
      { value: 12, text: "Dezembro" },
    ],
    month: "",
    years: [],
    year: "",
    companies: [],
    billing_types: [
      { value: 1, text: "Normal" },
      { value: 2, text: "Retificação" },
    ],
    billing_type: 1,
    types_installment: [
      { value: 1, text: "Nº de Parcelas" },
      { value: 2, text: "Valor das Parcelas" },
    ],
    installment: 1,
    company: "",
    loading: false,
    successSave: false,
    lazy: false,
    valid: true,
  }),
  computed: {},
  created() {
    let dateNow = new Date();
    this.month = dateNow.getMonth() + 1;
    this.year = dateNow.getFullYear();
    let yearNow = dateNow.getFullYear();

    // COLOCA 10 ANOS PARA TRAS
    for (let i = 10; i >= 0; i--) {
      this.years.push(yearNow - i);
    }
    this.years = this.years.reverse();
    this.initialize();
  },
  methods: {
    async initialize() {
      this.getCompanies();
    },
    async getCompanies() {
      // this.loading = true;
      try {
        let data = await CompanyAPI.getAll("?type=fra,mul");
        this.companies = data.sort((a, b) => (a.code > b.code ? 1 : -1));
      } catch (error) {
        this.companies = [];
        console.log(error);
      } finally {
        // this.loading = false;
      }
    },
    validate() {},
  },
};
</script>
